<template>
    <b-modal
        id="add-slu-cohort-modal"
        ref="add-slu-cohort-modal"
        size="lg"
        :title="$t('slu_dashboard.add_grade')"
        modal-class="apprentice-default-modal add-slu-cohort"
        :ok-title="$t('common.save')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="show"
        @ok="onOk">
        <div class="add-slu-cohort">
            <div class="errors">
                <b-alert
                    v-if="hasError"
                    variant="danger"
                    show>
                    {{ $t('slu_dashboard.name_cannot_be_empty') }}
                </b-alert>
            </div>

            <b-form-group
                class="slu-cohort-name"
                label-for="slu-cohort-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span> </template>
                <b-form-input
                    id="slu-cohort-name-input"
                    v-model="name"
                    :placeholder="$t('slu_dashboard.grade_name')">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="slu-cohort-target"
                label-for="slu-cohort-target-input"
                label="target">
                <template v-slot:label>
                    {{ $t('slu_dashboard.minimum_percentage', { points_name: sluSchoolSettingsIn.name_points }) }}:
                    <span class="required">*</span>
                </template>
                <b-form-input
                    id="slu-cohort-target-input"
                    v-model="target"
                    type="number"
                    min="0"
                    max="100"
                    step="1"
                    :placeholder="
                        $t('slu_dashboard.minimum_percentage', { points_name: sluSchoolSettingsIn.name_points })
                    "
                    @blur="convertToInteger">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="slu-cohort-season"
                label-for="slu-cohort-season-input"
                :label="$t('slu_dashboard.season')">
                <b-form-select
                    class="apprentice-primary-select slu-cohort-season-select"
                    id="slu-cohort-season-input"
                    v-model="season"
                    v-if="seasonsIn.length"
                    :options="seasonsIn"
                    text-field="season"
                    value-field="id">
                </b-form-select>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-add-slu-cohort-modal-component',
    props: ['seasonsIn', 'sluCourseIn', 'sluSchoolSettingsIn'],
    data() {
        return {
            name: '',
            seasons: this.seasonsIn,
            target: null,
            season: this.seasonsIn.length > 0 ? this.seasonsIn[0].id : null,
            hasError: false,
        };
    },
    methods: {
        onOk(bvModal) {
            this.hasError = false;

            if (this.name === null || this.name === '') {
                this.hasError = true;
                bvModal.preventDefault();
                return;
            }

            let data = {
                name: this.name,
                seasonId: this.season,
                target: this.target,
            };
            this.alert.saving();

            this.axios.post(this.routes.sluCohort(this.sluCourseIn.id), data).then(
                (response) => {
                    this.$emit('updateCohorts', response.data);
                    this.alert.success();
                },
                (error) => {
                    return this.alert.ajaxError(error);
                },
            );
        },

        show() {
            this.name = '';
            this.seasons = this.seasonsIn;
            this.target = null;
            this.season = this.seasonsIn.length > 0 ? this.seasonsIn[0].id : null;
        },

        convertToInteger() {
            this.target = parseInt(this.target);
        },
    },
};
</script>

<style scoped lang="scss">
.add-slu-cohort {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    align-content: flex-start;
    column-gap: $grid-gutter-width;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');

    input,
    select {
        margin-bottom: 0;
    }

    select {
        width: 100%;
    }

    .errors {
        flex: 1 0 100%;
    }

    .form-group {
        margin-bottom: 0;
        width: 100%;
    }

    .slu-cohort-season {
        align-self: flex-start;
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .update-slu-cohort {
        .form-group {
            width: auto;
        }
    }

    .slu-cohort-name {
        flex: 1 1 calc(50% - 15px);
    }

    .slu-cohort-target {
        flex: 0 1 calc(30% - 15px);
    }

    .slu-cohort-season {
        flex: 0 1 calc(18% - 15px);
    }
}
</style>
